<template>
  <header>
    <b-navbar class="shadow-sm" toggleable="lg" type="light" variant="light">
      <b-navbar-brand :to="{ name: 'home' }" target="_blank">
        <img src="@/assets/img/logoDlibr.png" class="brand-logo" alt="Dlibr" />
      </b-navbar-brand>
      <b-nav
        class="w-100 d-none d-lg-inline-flex align-items-center pl-5"
        align="left"
      >
        <template
          v-if="['home', 'about', 'teachers.register', 'not-found'].includes($route.name)"
        >
          <b-nav-item :active="$route.name === 'home'" :to="{ name: 'home' }">
            Accueil
          </b-nav-item>
          <b-nav-item-dropdown :active="$route.name === 'about'" text="À propos" :to="{ name: 'about' }">
            <b-dropdown-item :to="{ name: 'about', query: { to: 'pedago'} }">Approche pédagogique</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'about', query: { to: 'droits'} }">Droits d’utilisation</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'about', query: { to: 'generique'} }">Générique du site</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'about', query: { to: 'remerciements'} }">Remerciements</b-dropdown-item>
          </b-nav-item-dropdown>
        </template>
        <template
          v-else-if="$route.name ? $route.name.includes('teacher') : false"
        >
          <b-nav-item
            :active="
              ['teacher.own.deliberations', 'teachers.deliberations'].includes(
                $route.name
              )
            "
            :to="{
              name: 'teacher.own.deliberations',
              params: { id: profile.id }
            }"
            >Vos délibérations</b-nav-item
          >
          <b-nav-item
            :active="$route.name == 'teachers.participants'"
            :to="{ name: 'teachers.participants', params: { id: profile.id } }"
            >Participants</b-nav-item
          >
          <b-nav-item
            :active="$route.name == 'teachers.groups'"
            :to="{
              name: 'teachers.groups',
              params: { id: profile.id }
            }"
            >Groupes</b-nav-item
          >
          <b-nav-item
            :active="$route.name == 'teachers.evaluations'"
            :to="{ name: 'teachers.evaluations', params: { type: 'grille' } }"
            >Évaluations</b-nav-item
          >
        </template>
        <template
          v-else-if="$route.name ? $route.name.includes('admin') : false"
        >
          <b-nav-item
            :active="$route.name == 'admin.notifications'"
            :to="{ name: 'admin.notifications' }"
            >Notifications</b-nav-item
          >
          <b-nav-item
            :active="$route.name == 'admin.users'"
            :to="{ name: 'admin.users' }"
            >Utilisateurs</b-nav-item
          >
          <b-nav-item
            :active="$route.name == 'admin.rules'"
            :to="{ name: 'admin.rules' }"
            >Règles</b-nav-item
          >
        </template>
        <template
          v-else-if="$route.name ? $route.name.includes('student') : false"
        >
          <b-nav-item
            :active="$route.name == 'student.own.deliberations'"
            :to="{
              name: 'student.own.deliberations',
              params: { id: profile.id }
            }"
            >Mes Délibérations</b-nav-item
          >
          <b-nav-item
            v-if="profile.role !== 'guest'"
            :active="$route.name == 'student.results'"
            :to="{ name: 'student.results', params: { id: profile.id } }"
            >Résultats</b-nav-item
          >
        </template>
      </b-nav>
      <b-dropdown
        v-if="ifAuthenticated"
        right
        variant="link"
        toggle-class="text-decoration-none"
        no-caret
        class="d-none d-lg-inline-flex"
      >
        <template v-slot:button-content>
          <b-btn pill variant="primary">
            <small>{{ userInitials | toUpperCase }}</small>
          </b-btn>
        </template>
        <!-- <b-dropdown-item :to="{ name: 'teachers.profile' }"
          >Voir mon profil</b-dropdown-item
        > -->
        <b-dropdown-item @click="onLogout">Déconnexion</b-dropdown-item>
      </b-dropdown>

      <b-btn
        :to="{ name: 'teachers.register' }"
        class="text-white btn-register d-none d-lg-inline-flex"
        pill
        variant="info"
        v-if="!ifAuthenticated"
      >
        Demander un compte
      </b-btn>

      <b-btn
        variant="primary"
        pill
        v-if="!ifAuthenticated"
        class="ml-4 d-none d-lg-block btn-connect"
        :to="{ name: 'auth.login.options' }"
        >Se connecter</b-btn
      >
      <b-navbar-brand href="https://ccdmd.qc.ca" target="_blank" class="ccdmd-logo">
        <img src="@/assets/img/u50.png" class="brand-logo ml-5" alt="CCDMD"  />
      </b-navbar-brand>

      <b-navbar-toggle target="none" v-b-toggle.sidebar-menu></b-navbar-toggle>
    </b-navbar>
    <b-sidebar backdrop id="sidebar-menu" title="Sidebar" shadow>
      <template v-slot:title>
        <b-navbar-brand>
          <img
            src="@/assets/img/logoDlibr.png"
            class="brand-logo d-inline-block align-center"
            alt="Dlibr"
          />
        </b-navbar-brand>
      </template>

      <b-nav vertical class="text-center">
        <template
          v-if="$route.name == 'home' || $route.name == 'about' || $route.name == 'teachers.register'"
        >
          <b-nav-item :to="{ name: 'home' }">
            Accueil
          </b-nav-item>
          <b-nav-item-dropdown :active="$route.name === 'about'" text="À propos" :to="{ name: 'about' }">
            <b-dropdown-item :to="{ name: 'about', query: { to: 'pedago'} }">Approche pédagogique</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'about', query: { to: 'droits'} }">Droits d’utilisation</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'about', query: { to: 'generique'} }">Générique du site</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'about', query: { to: 'remerciements'} }">Remerciements</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item v-if="!ifAuthenticated" class="mt-2">
            <b-btn
              :to="{ name: 'teachers.register' }"
              class="text-white"
              pill
              variant="info"
            >
              Demander un compte
            </b-btn>
          </b-nav-item>

          <b-nav-item v-if="!ifAuthenticated" class="mt-2">
            <b-btn
              variant="primary"
              pill
              class="btn-connect"
              :to="{ name: 'auth.login.options' }"
            >
              Se connecter
            </b-btn>
          </b-nav-item>
        </template>
        <template
          v-else-if="$route.name ? $route.name.includes('teacher') : false"
        >
          <b-nav-item
            :active="
              ['teacher.own.deliberations', 'teachers.deliberations'].includes(
                $route.name
              )
            "
            :to="{
              name: 'teacher.own.deliberations',
              params: { id: profile.id }
            }"
            >Vos délibérations</b-nav-item
          >
          <b-nav-item
            :active="$route.name == 'teachers.participants'"
            :to="{ name: 'teachers.participants', params: { id: profile.id } }"
            >Participants</b-nav-item
          >
          <b-nav-item
            :active="$route.name == 'teachers.groups'"
            :to="{ name: 'teachers.groups', params: { id: profile.id } }"
            >Groupes</b-nav-item
          >
          <b-nav-item
            :active="$route.name == 'teachers.evaluations'"
            :to="{ name: 'teachers.evaluations', params: { type: 'grille' } }"
            >Évaluations</b-nav-item
          >
        </template>
        <template
          v-else-if="$route.name ? $route.name.includes('admin') : false"
        >
          <b-nav-item
            :active="$route.name == 'admin.notifications'"
            :to="{ name: 'admin.notifications' }"
            >Notifications</b-nav-item
          >
          <b-nav-item
            :active="$route.name == 'admin.users'"
            :to="{ name: 'admin.users' }"
            >Utilisateurs</b-nav-item
          >
          <b-nav-item
            :active="$route.name == 'admin.rules'"
            :to="{ name: 'admin.rules' }"
            >Règles</b-nav-item
          >
        </template>
        <template
          v-else-if="$route.name ? $route.name.includes('student') : false"
        >
          <b-nav-item
            :active="$route.name == 'student.deliberations'"
            :to="{ name: 'student.deliberations' }"
            >Mes Délibérations</b-nav-item
          >
          <b-nav-item
            :active="$route.name == 'student.results'"
            :to="{ name: 'student.results', params: { id: profile.id } }"
            >Résultats</b-nav-item
          >
        </template>
      </b-nav>

      <template v-slot:footer>
        <div
          v-if="ifAuthenticated"
          class="container d-flex bg-primary text-light  justify-content-between align-items-center py-2"
        >
          <b-btn pill variant="light">
            <small>{{ userInitials | toUpperCase }}</small>
          </b-btn>
          <b-button pill size="sm" variant="light" @click="onLogout"
            >Déconnexion</b-button
          >
        </div>
      </template>
    </b-sidebar>
  </header>
</template>

<script>
/**
 * @file       Layout site navigation bar component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { mapState } from "vuex";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "siteNavbar",

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    ...mapState({
      ifAuthenticated: state => !!state.auth.profile.data,
      profile: state =>
        state.auth.profile.data ? state.auth.profile.data.data.find(u => u) : {}
    }),

    /**
     * Current user's initials.
     *
     * @return      {string}  Initials of name or nickname
     */
    userInitials() {
      return this.profile.name
        ? `${this.profile.name.charAt(0)}${this.profile.last_name.charAt(0)}`
        : this.profile.nickname
        ? this.profile.nickname.slice(0, 2)
        : "";
    },

    /**
     * Check if the user is an admin.
     *
     * @return      {Bool}  true or false
     */
    userIsAdmin() {
      return (
        this.$store.state.auth.profile.data.data.find(u => u).role ==
        "ROLE_ADMIN"
      );
    }
  },

  /**
   * Watch properties.
   */
  watch: {
    /**
     * Watches the $route and srolls at the right element.
     *
     * @param      {object}  toRoute    To route
     */
    $route (toRoute) {
      if (toRoute.query.to !== '') {
        setTimeout(() => {
          this.scrollIntoView(toRoute.query.to);
        }, 500);
      }
    }
  },

  /**
   * On mounted event.
   */
  mounted () {
    // Also scroll to the right element.
    if (this.$route.query.to !== '') {
      this.scrollIntoView(this.$route.query.to);
    }
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Scroll element into the view.
     *
     * @param      {Object}  elem     The element to scroll into the view
     */
    scrollIntoView(elem) {
      document.getElementById(elem).scrollIntoView({ behavior: "smooth" });
    },

    /**
     * Logout.
     */
    onLogout() {
      this.$store.dispatch("auth/logout").then(() => {
        this.$router.push({ name: "auth.login.options" });
      });
    }
  }
};
</script>

<style lang="scss">
.btn-connect {
  white-space: nowrap;
}

.nav-link {
  padding: 5px 0;
  margin:  0.5rem 1rem;

  &.active {
    border-bottom: 2px solid #EFB708;
  }
}

@media only screen and (max-width: 991px) {
  .ccdmd-logo {
    display: none;
  }
}
</style>
